import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import config from './config.json';

if (!('services' in window)) {
  window.services = {};
}

const isAcceptance = process.env.REACT_APP_GUILD_BASE_URL?.includes('guildacceptance.com');

config.services.forEach(({ subdomain }) => {
  const envSubdomain = isAcceptance ? `${subdomain}-staging` : subdomain;
  const NAME = snakeCase(subdomain).toUpperCase().replace(/\./, '_');
  const envKey = `REACT_APP_${NAME}_URL`;
  const defaultUrl = `https://${envSubdomain}.${process.env.REACT_APP_GUILD_BASE_URL}`;

  window.services[camelCase(subdomain)] = process.env[envKey] || defaultUrl;
});

import(/* webpackChunkName: "host" */ './index');
